<mat-tab-group
  [selectedIndex]="tundishSelected"
  (selectedTabChange)="onTabClick($event)"
>
  <mat-tab
    *ngFor="let device of tundishDevices"
    aria-label="{{ device.uuid }}"
    label="{{ device.nombre }}"
  >
    <ng-template mat-tab-label>
      <mat-icon
        *ngIf="device.active"
        class="material-icons-outlined"
        color="warn"
        style="margin-right: 5px"
        >sync</mat-icon
      >
      {{ device.nombre }}
    </ng-template>
    <ng-template matTabContent>
      <!-- TAB 1 Tundish 1-->
      <div style="margin: 20px">
        <mat-card>
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Indicadores de Producción de Acero</mat-card-title
          >
          <mat-card-subtitle style="padding: 0px 0 0px 20px">{{
            device.nombre
          }}</mat-card-subtitle>
          <!--<mat-card-title><span style="padding: 10px;">List of Orders</span></mat-card-title>-->
          <mat-card-content>
            <div style="float: left">
              <mat-form-field style="padding-left: 20px">
                <input
                  matInput
                  type="text"
                  (keyup)="doFilter(0, $event)"
                  placeholder="Filter"
                />
              </mat-form-field>
            </div>
            <div style="float: right">
              <!-- <button mat-raised-button (click)="doOpenDialog(2, -1, -1, device.uuid)" color="primary" style="margin: 0px 20px 10px 0px;">Añadir</button> -->
              <button
                mat-raised-button
                (click)="doOpenDialog(2, -1, -1, device.uuid, null, null)"
                color="primary"
                style="margin: 0px 20px 10px 0px"
              >
                Añadir
              </button>
            </div>
            <div style="clear: both"></div>
            <table
              #consumptionsTable
              mat-table
              [dataSource]="dataSourceTundishConsumptionsSimple"
              class="mat-elevation-z8"
            >
              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="uuid">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  UUID
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ element._id }}
                </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="fecha">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Fecha
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ doTransformDate(element.fecha * 1000) }}
                </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="consumo">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Producción
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ element.consumo }} Tn
                </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="coladas">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Coladas
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  {{ element.coladas }}
                </td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="text-align: center"
                >
                  Acciones
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-align: center"
                >
                  <button
                    mat-raised-button
                    (click)="
                      doOpenDialog(
                        2,
                        element._id,
                        0,
                        element.disp,
                        -1 - 1,
                        null
                      )
                    "
                    color="accent"
                    style="margin: 5px 2px"
                  >
                    Editar
                  </button>
                  <button
                    mat-raised-button
                    (click)="
                      doOpenDialog(2, element._id, 1, element.disp, -1, -1)
                    "
                    color="warn"
                    style="margin: 5px 2px"
                  >
                    Eliminar
                  </button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsTundishConsumptions"
              ></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  columns: displayedColumnsTundishConsumptions
                "
              ></tr>
            </table>
            <mat-paginator
              #consumptionsPaginator
              [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
            ></mat-paginator>
            <div style="padding: 0 15px 15px 15px">
              <mat-card>
                <mat-card-title style="padding: 10px 0 0px 20px"
                  >Listado de Campañas</mat-card-title
                >
                <mat-card-subtitle style="padding: 0px 0 0px 20px">{{
                  device.nombre
                }}</mat-card-subtitle>
                <!--<mat-card-title><span style="padding: 10px;">List of Orders</span></mat-card-title>-->
                <mat-card-content>
                  <div style="float: left">
                    <mat-form-field style="padding-left: 20px">
                      <input
                        matInput
                        type="text"
                        (keyup)="doFilter(0, $event)"
                        placeholder="Filter"
                      />
                    </mat-form-field>
                  </div>
                  <div style="float: right">
                    <button
                      mat-raised-button
                      (click)="doOpenDialog(0, -1, -1, device.uuid, null, null)"
                      color="primary"
                      style="margin: 0px 20px 10px 0px"
                    >
                      Añadir
                    </button>
                  </div>
                  <div style="clear: both"></div>
                  <table
                    #campaignsTable
                    mat-table
                    [dataSource]="dataSourceTundishCampaignsSimple"
                    class="mat-elevation-z8"
                  >
                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="uuid">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        UUID
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element._id }}
                      </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="campaña">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Campaña
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element.nombre }}
                      </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <!--
                  <ng-container matColumnDef="tundish">
                    <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Tundish </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.disp}} </td>
                  </ng-container>
                  -->

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="inicio">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Inicio
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ doTransformDate(element.inicio * 1000) }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="fin">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Finalización
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ doTransformDate(element.fin * 1000) }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="duracion">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Duración
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        {{ element.duracion }}
                      </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="estado">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Estado
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          mat-raised-button
                          [color]="
                            element.estado == 'EN CURSO' ? 'accent' : 'warn'
                          "
                        >
                          {{ element.estado }}
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="visualizar">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Visualizar
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              -1,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Operaciones
                        </button>
                        <button
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              2,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Alarmas
                        </button>
                        <button
                          *ngIf="element.estado == 'FINALIZADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              3,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          Informe
                        </button>
                        <button
                          *ngIf="element.estado == 'FINALIZADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              4,
                              element.disp,
                              element.inicio,
                              element.fin
                            )
                          "
                          color="primary"
                          style="margin: 5px 2px"
                        >
                          KPIs
                        </button>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        style="text-align: center"
                      >
                        Acciones
                      </th>
                      <td
                        mat-cell
                        *matCellDef="let element"
                        style="text-align: center"
                      >
                        <button
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              0,
                              element.disp,
                              -1 - 1,
                              null
                            )
                          "
                          color="accent"
                          style="margin: 5px 2px"
                        >
                          Editar
                        </button>
                        <button
                          *ngIf="element.estado == 'NO INICIADO'"
                          mat-raised-button
                          (click)="
                            doOpenDialog(
                              0,
                              element._id,
                              1,
                              element.disp,
                              -1,
                              -1
                            )
                          "
                          color="warn"
                          style="margin: 5px 2px"
                        >
                          Eliminar
                        </button>
                        <!--<button *ngIf="element.estado == 'NO INICIADO'" mat-raised-button (click)="doOpenDialog(0, element._id, 1, element.disp, -1, -1)" color="warn" style="margin: 5px 2px;">Eliminar</button>-->
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsTundishCampaigns"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="
                        let row;
                        columns: displayedColumnsTundishCampaigns
                      "
                      (click)="doHighlight(row)"
                      [style.background]="
                        highlightedRows.indexOf(row) != -1 ? 'lightblue' : ''
                      "
                    ></tr>
                  </table>
                  <mat-paginator
                    #campaignsPaginator
                    [pageSizeOptions]="[5, 10, 20]"
                    showFirstLastButtons
                  ></mat-paginator>
                  <div style="padding: 0 15px 15px 15px">
                    <mat-card>
                      <mat-card-title style="padding-left: 20px"
                        >Listado de Operaciones</mat-card-title
                      >
                      <mat-card-subtitle style="padding-left: 20px"
                        >Campaign:
                        {{ currentTundishCampaign }}</mat-card-subtitle
                      >
                      <mat-card-content>
                        <div>
                          <mat-form-field style="padding-left: 20px">
                            <input
                              matInput
                              type="text"
                              (keyup)="doFilter(1, $event)"
                              placeholder="Filter"
                            />
                          </mat-form-field>
                        </div>
                        <table
                          #operationsTable
                          mat-table
                          [dataSource]="dataSourceTundishOperationsSimple"
                          class="mat-elevation-z8"
                        >
                          <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

                          <!-- Position Column -->
                          <ng-container matColumnDef="uuid">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              UUID
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element._id }}
                            </td>
                          </ng-container>

                          <!-- Name Column -->
                          <!--
                        <ng-container matColumnDef="campaña">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Campaña </th>
                          <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.campaign}} </td>
                        </ng-container>
                        -->

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="inicio">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Inicio
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ doTransformDate(element.inicio * 1000) }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="fin">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Finalización
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ doTransformDate(element.fin * 1000) }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="duracion">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Duración
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ element.fin - element.inicio }}
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="arena">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Arena
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{ doRoundNumber(element.campos.arena.kilos) }}
                              kgs
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="silicato">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Silicato
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{
                                doRoundNumber(element.campos.silicato.litros)
                              }}
                              lts
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="catalizador">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Catalizador
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              {{
                                doRoundNumber(element.campos.catalizador.litros)
                              }}
                              lts
                            </td>
                          </ng-container>

                          <!-- Symbol Column -->
                          <ng-container matColumnDef="estado">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Estado
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                [color]="element.fin == 0 ? 'accent' : 'warn'"
                              >
                                {{
                                  element.fin == 0 ? "EN CURSO" : "FINALIZADO"
                                }}
                              </button>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="consumos">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Consumos
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    2,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Arena
                              </button>
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    3,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Silicato
                              </button>
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    6,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Catalizador
                              </button>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="visualizar">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Visualizar
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    4,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Alarmas
                              </button>
                              <button
                                *ngIf="element.fin != 0"
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    5,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Informe
                              </button>
                              <button
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    7,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="primary"
                                style="margin: 5px 2px"
                              >
                                Intervalos
                              </button>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="acciones">
                            <th
                              mat-header-cell
                              *matHeaderCellDef
                              style="text-align: center"
                            >
                              Acciones
                            </th>
                            <td
                              mat-cell
                              *matCellDef="let element"
                              style="text-align: center"
                            >
                              <button
                                *ngIf="element.fin != 0"
                                mat-raised-button
                                (click)="
                                  doOpenDialog(
                                    1,
                                    element._id,
                                    8,
                                    element.disp,
                                    element.inicio,
                                    element.fin
                                  )
                                "
                                color="accent"
                                style="margin: 5px 2px"
                                [disabled]="!isAdmin"
                              >
                                Reasignar
                              </button>
                            </td>
                          </ng-container>

                          <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumnsTundishOperations"
                          ></tr>
                          <tr
                            mat-row
                            *matRowDef="
                              let row;
                              columns: displayedColumnsTundishOperations
                            "
                          ></tr>
                        </table>
                        <mat-paginator
                          #operationsPaginator
                          [pageSizeOptions]="[5, 10, 20]"
                          showFirstLastButtons
                        ></mat-paginator>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
